import React from 'react'
import { CountrySettingList } from './list/page'

export const CountrySettingPage: React.FC = () => {
  return <CountrySettingList />
}
